import script from "./TopOrganizationPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopOrganizationPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopOrganizationPanel.vue?vue&type=style&index=0&id=1690f0ba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1690f0ba"]])

export default __exports__